<template>
  <div class="order-detail">
    <div class="order-wrapper">
      <h3 class="title">确认订单</h3>
      <div class="order-info-box">
        <div class="order-content-info">
          <img :src="orderInfo.courseVo.imageUrl" class="con-img"/>
          <div class="con-info">
            <div class="title">
              <span
                  :style="'padding:0px 5px;color:#ffffff;border-radius: 3px;background:'+orderInfo.courseVo.plateColor"
                  v-if="orderInfo.courseVo.plateName">{{ orderInfo.courseVo.plateName }}
              </span>
              {{ orderInfo.courseVo.title }}
            </div>
            <div class="price-container">
              <div class="discount-price">￥{{ orderInfo.courseVo.price }}</div>
              <div class="original-price">￥{{ orderInfo.courseVo.price }}</div>
            </div>
          </div>
        </div>
        <div class="order-content-num">
          <h3>优惠信息</h3>
          <div class="bdl1 con-price">商品价格：<span>￥{{ orderInfo.courseVo.price }}</span></div>
          <div class="bdl1 con-number">优惠价格：<span>￥{{ orderInfo.courseVo.price }}</span></div>
          <div class="bdl1 con-pain-in">
            应付合计金额：<span>￥{{ orderPrice.payPrice }}</span>
          </div>
        </div>
        <div class="order-content-pay">
          <h3>支付方式</h3>
          <div class="pay-line">
            <ul class="order-pay-nav">
              <li :class="paystyle =='weixin'?'active':''">
                <a @click="payItem('weixin')"><img src="@/assets/images/weixinpay.jpg"
                                                   width="30"/><span>微信支付</span></a>
              </li>
              <!--            <li :class="paystyle =='alipay'?'active':''">-->
              <!--              <a @click="payItem('alipay')"><img src="@/assets/images/alipay.jpg"-->
              <!--                                                 width="30"/><span>支付宝支付</span></a>-->
              <!--            </li>-->
              <!--            <li :class="paystyle =='yue'?'active':''">-->
              <!--              <a @click="payItem('yue')"><span>平台支付</span></a>-->
              <!--            </li>-->
            </ul>
            <div class="order-content-submit">
              <div class="order-submit-row">
                <!-- 添加勾选框 -->
                <input type="checkbox" v-model="checked">
                <div @click="buyAgreement()">购买协议</div>
              </div>
              <div class="order-submit" @click="cnofigSubm">去结算</div>
            </div>
          </div>
        </div>

      </div>
      <a-modal title="微信支付" :visible="show" @cancel="weixinCancel" class="custom-modal">
        <div class="paycode">
          <div id="qrcodeImg" class="img"></div>
          <div style="margin-top:10px;" @click="weixinCancel">
            {{ paytext }}
            <span>支付完成后，请在个人中心=>订单页面查看</span>
          </div>
        </div>
        <template #footer>
          <div class="footer">
            <!-- 自定义取消按钮 -->
            <a-button @click="weixinCancel">取消</a-button>
            <!-- 自定义确认按钮 -->
            <a-button type="primary" @click="payOKtoCenter(2)">确认</a-button>
          </div>

        </template>
      </a-modal>
    </div>
  </div>

</template>

<script>
import {
  getOrderConfirm,
  getOrderCreate,
  getOrderComputed
} from "@/api/CourseCenter"
import QRCode from 'qrcodejs2'


// 定义常量
const ORDER_STATUS_SUCCESS = 200;

export default {
  name: "order",
  computed: {},
  components: {},
  data() {
    return {
      show: false,
      checked: false, // 勾选状态
      codes: "",//支付二维码链接
      cartId: 0,
      orderPrice: {},
      orderKey: '',
      courseId: 0,
      orderInfo: {},
      paystyle: 'weixin',
      paytext: '使用微信扫描二维码进行支付',
      orderSubmit: {},
    }
  },
  watch: {},
  created() {
  },
  mounted() {
    // 获取订单ID
    this.courseId = this.$route.params.courseId;
    console.log("课程ID：" + this.courseId);
    this.orderConfirm();
  },
  methods: {
    //选择支付类型
    payItem(type) {
      console.log("选择支付：" + type)
      this.paystyle = type;
    },
    //取消微信支付
    weixinCancel() {
      this.show = false;
      this.payOKtoCenter(1); // 返回查看订单
    },
    // 计算订单
    orderConfirm() {
      console.log("确认订单，课程ID：" + this.courseId);
      getOrderConfirm({courseId: this.courseId, courseType: 0}).then(res => {
        if (res.status === ORDER_STATUS_SUCCESS) {
          this.orderInfo = res.data;
          this.orderKey = res.data.orderKey;
          console.log("订单信息：", this.orderInfo);
          getOrderComputed(this.orderKey).then(res => {
            if (res.status === ORDER_STATUS_SUCCESS) {
              this.orderPrice = res.data.result;
            }
          });
        } else {
          this.$message.error("提交订单异常");
        }
      }).catch(e => {
        this.$message.error(e.msg || "未知错误");
      });
    },
    // 准备支付
    cnofigSubm() {
      // 验证勾选状态
      if (!this.checked) {
        this.$message.error('请先阅读并同意课程购买协议');
        return;
      }
      getOrderCreate(this.orderKey, {
        couponId: 0,
        isChannel: 1,
        payType: this.paystyle,
        from: 'pc',
        useIntegral: ''
      }).then(res => {
        if (res.status === ORDER_STATUS_SUCCESS) {
          if (res.data.result && res.data.result.orderId) {
            let jsConfig = res.data.result.jsConfig;
            if (jsConfig) {
              this.codes = res.data.result.jsConfig.codeUrl;
              this.$nextTick(() => {
                this.qrCode();
              });
              this.$message.info("二维码生成中");
            } else {
              this.$message.warn(res.msg);

            }
          }
        }
      });
    },
    // 支付状态
    qrCode() {
      this.show=true;
      let time = setTimeout(() => {
        document.getElementById("qrcodeImg").innerHTML = "";
        new QRCode(document.getElementById("qrcodeImg"), {
          text: this.codes, // 需要转换为二维码的内容
          width: 260,//二维码的宽度
          height: 260,//二维码的高度
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        clearTimeout(time);
      }, 100);
    },
    payOKtoCenter(a) {
      if (a === 1) {
        let id= this.courseId
        this.$router.replace({name: "CourseDetail", params: {id}});
      } else {
        this.$router.replace({path: "/UserCenter"});
      }
    },
    buyAgreement(){
      this.$router.replace({path: "/BuyAgreement"});
    }
  }
};
</script>

<style lang="scss">
.order-detail {
  background: #F7F8FA;
  padding: 20px 0;

  .order-wrapper {
    margin: 0 auto;
    width: 1280px;
    background: #ffffff;
    border-radius: 10px;

    .title {
      text-align: left;
      padding-left: 20px;
      padding-top:20px;
      border: 50px;
      font-size: 18px;
    }

    .order-info-box {
      margin-bottom: 10px;

      .complete-bg {
        background: rgb(122 36 137 / 9%) !important;
      }

      .complete-border {
        border: 1px solid rgb(122 36 137 / 9%) !important;
      }

      .order-title {
        padding: 0 16px 0 22px;
        height: 41px;
        line-height: 41px;
        background-color: #f2f2f2;
        display: flex;
        justify-content: space-between;
      }

      .order-info {
        font-size: 15px;
      }

      .order-info span {
        display: inline-block;
        line-height: 41px;
      }

      .square {
        display: inline-block;
        width: 13px;
        height: 13px;
        border: 1px solid #797979;
        margin-right: 14px;
      }

      .order-date {
        margin-right: 40px;
        color: #333;
      }

      .order-number {
        color: #7f7f7f;
      }

      .order-btn span {
        display: inline-block;
        margin-left: 40px;
        line-height: 41px;
        color: #333;
        cursor: pointer;
        transition: 0.2s;
      }

      .order-btn span:hover {
        color: #da514e;
      }

      .order-content-info {
        padding: 20px;
        display: flex;
        justify-content: left;
        border-bottom: 2px dashed #f2f2f2;

        .con-img {
          width: 200px;
          height: 113px;
        }

        .con-info {
          .title {
            line-height: 20px;
            font-size: 18px;
            color: #333;
            display: flex;
          }

          .title span {
            display: block;
            line-height: 20px;
            margin-right: 10px;
          }

          span {
            display: block;
            padding-top: 14px;
            line-height: 13px;
            font-size: 14px;
            color: #7f7f7f;
          }

          .price-container {
            display: flex;
            align-items: center;
            padding-top: 80px;
            padding-left: 20px;
            height: 24px;
            line-height: 24px;

            .discount-price {
              color: #df7645;
              margin-right: 10px;
              font-size: 24px;
            }

            .original-price {
              font-size: 16px;
              text-decoration: line-through;
              color: #999;
            }
          }
        }

      }

      .order-content-num {
        padding: 20px;
        border-bottom: 2px dashed #f2f2f2;
        h3 {
          font-size: 16px;
        }

        .bdl1 {
          height: 30px;
          display: flex;
          justify-content: space-between;

          span {
            font-size: 18px;
            text-align: right;
          }
        }

        .con-price {
          line-height: 25px;
          font-size: 16px;
          color: #7f7f7f;
          display: flex;
          justify-content: space-between;

          span {
            font-size: 18px;
            text-align: right;
          }
        }

        .con-number {
          line-height: 25px;
          font-size: 16px;
          color: #7f7f7f;
          display: flex;
          justify-content: space-between;

          span {
            color: #df7645;
            font-size: 18px;
            text-align: right;
          }
        }

        .con-pain-in {
          line-height: 25px;
          font-size: 16px;
          color: #333;
        }

        .con-pain-in span {
          color: #da514e;
          font-weight: 700;
        }
      }

      .order-content-pay{
        padding: 20px;
        text-align: left;
        border: 1px solid #f2f2f2;

        h3{
          font-size: 20px;
          margin-bottom: 10px;
        }
        .pay-line{
          display: flex;
          justify-content: space-between;
          height: 40px;
          .order-pay-nav{
            margin-top: 10px;
            width: 800px;
            height: 40px;
            display:flex;
            justify-content: space-between;
            li a{ margin-right: 20px; height:100%; padding:10px 10px; position: relative;background: #ffffff;
              box-shadow: 2px 0 4px rgba(0,0,0,0.4);border-radius:5px; font-size: 16px;font-weight: 400;}
          }
          .order-content-submit {
            display: flex;
            justify-content: space-between;
            width: 240px;
            .order-submit-row {
              width: 120px;
              display: flex;
              align-items: center;
              height: 35px;
              line-height: 35px;
              input[type="checkbox"] {
                margin-right: 5px;
                width: 20px;
              }
            }

            .order-submit {
              width: 100px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              font-size: 16px;
              border-radius: 4px;
              background: #E28947;
              color: #ffffff;
            }
          }
        }

      }

    }

  }

}


.custom-modal .ant-modal {
  width: 310px !important;
  border-radius: 6px;
}

.custom-modal .ant-modal-content {
  width: 310px !important;
  height: 480px;
  display: flex;
  flex-direction: column;
}

.custom-modal .ant-modal-body {
  width: 310px !important;
  height: 380px !important;
  padding: 5px ;
  flex: 1;
}
.custom-modal .ant-modal-footer{
  padding: 10px 5px !important;
}
.paycode {
  width: 300px;
  min-height: 300px;
  background-color: #fff;
  text-align: center;
  .img{
    padding: 10px 20px;
  }
}



</style>
